import React from "react";
import { Dropdown } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleDropdownProps extends React.ComponentProps<typeof Dropdown> {
  useEditorTheme?: boolean;
}

const TrebbleDropdown = ({ useEditorTheme, ...restProps }: TrebbleDropdownProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Dropdown {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleDropdown; 